import type { LineSeries, Point } from '@nivo/line';
import { useBridgeContext } from '@sendible/shared-state-bridge';
import { useTranslation } from 'react-i18next';
import { useTikTokReportContext } from '../../../context';

export const Tooltip = ({ point }: { point: Point<LineSeries> }) => {
  const { userOffset } = useTikTokReportContext();
  const [
    {
      user: { language },
    },
  ] = useBridgeContext();
  const { t } = useTranslation('reports');
  const dt = new Date(String(point.data.x ?? ''));

  dt.setHours(dt.getHours() + userOffset / 60);

  const formattedDate = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short' }).format(dt);

  return (
    <div
      style={{
        padding: '0.5rem',
        background: 'white',
        border: '1px solid #ccc',
        textAlign: 'left',
        fontSize: '.75rem',
        borderRadius: '.25rem',
      }}
    >
      <strong>{String(point.seriesId)}</strong>
      <div>
        {t('date')}: {formattedDate}
      </div>
      <div>
        {t('value')}: {Number(point.data.y ?? 0).toLocaleString()}
      </div>
    </div>
  );
};
